import { __assign } from "tslib";
import React, { useEffect, useMemo } from 'react';
import { PortalIDProvider } from './context';
/**
 * private, do not use this directly
 */
var RcPortalRenderer = function (_a) {
    var portalDescriptor = _a.portalDescriptor;
    var Component = portalDescriptor.Component, _props = portalDescriptor.props, onMounted = portalDescriptor.onMounted, onUnmounted = portalDescriptor.onUnmounted, onClose = portalDescriptor.onClose, open = portalDescriptor.open, id = portalDescriptor.id;
    useEffect(function () {
        onMounted();
        return function () { return onUnmounted(); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var element = useMemo(function () {
        // onClose, open must be covered
        var props = __assign(__assign({}, _props), { onClose: onClose, open: open });
        return React.createElement(Component, __assign({}, props));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_props, open]);
    return React.createElement(PortalIDProvider, { value: id }, element);
};
RcPortalRenderer.displayName = 'RcPortalRenderer';
export { RcPortalRenderer };
